(function () {
const $180f3e6d2f8a0848$var$handleClickBehavior = (event)=>{
    const $clickedElement = event.currentTarget;
    const idToScroll = $clickedElement.getAttribute('data-scroll-to');
    const $elementToScroll = document.querySelector(`#${idToScroll}`);
    if ($elementToScroll) $elementToScroll.scrollIntoView();
};
const $180f3e6d2f8a0848$var$bindButtons = ()=>{
    const $buttons = document.querySelectorAll('[data-scroll-to]');
    $buttons.forEach(($singleButton)=>{
        $singleButton.disabled = false;
        $singleButton.addEventListener('click', $180f3e6d2f8a0848$var$handleClickBehavior);
    });
};
const $180f3e6d2f8a0848$var$initDragButtons = ()=>{
    $180f3e6d2f8a0848$var$bindButtons();
};
var $180f3e6d2f8a0848$export$2e2bcd8739ae039 = $180f3e6d2f8a0848$var$initDragButtons;


(0, $180f3e6d2f8a0848$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=script.js.map
